import he from "he";
import { S3_BASE_URL } from "../../../Service";
export const fixImagePaths = (htmlContent) => {
  if (!htmlContent) return "";
  let t = htmlContent.replace(/{{s3_base_url}}/g, `${S3_BASE_URL}`);
  return t;
};

export const decodeHtml = (htmlContent) => {
  htmlContent = fixImagePaths(htmlContent);
  const decodedHtml = he.decode(htmlContent);

  // if (!htmlContent) return "";
  // let t = htmlContent.replace(/src="static\//g, `src="${BASE_URL}/assets/`);
  // t = t.replace(/'assets\//g, `'${BASE_URL}/assets/`);
  return decodedHtml;
};

// for parsing data from admin panel
export const decodeAndStripHtml = (html) => {
  html = fixImagePaths(html);

  const decoded = he.decode(html);
  const doc = new DOMParser().parseFromString(decoded, "text/html");
  return doc.body.textContent || "";
};

// export const fetchRelaPro = (products, cat, subcat, prod) => {
//   const extractedProducts = [];
//   products &&
//     products.categories &&
//     products.categories.forEach((category) => {
//       if (category.categorySlug === cat) {
//         category.subCat &&
//           category.subCat.forEach((subCategory) => {
//             extractedProducts.push(...subCategory.products);
//           });
//         if (category.products) {
//           extractedProducts.push(...category.products);
//         }
//       }
//     });

//   return extractedProducts.filter((pro) => pro.productSlug !== prod);
// };
